import { createBrowserHistory } from 'history';

/**
 * Función para utilizar el objeto history 
 * del navegador en cualquier componente.
 */
export default createBrowserHistory({
  /* pass a configuration object here if needed */
})
